export default __webpack_public_path__ + "static/media/ic-first-grade.67369f18.svg";